/**
 * Extracts the subdomain from the given hostname.
 *
 * @param {string} hostname
 * @returns {string | null}
 */
export function extractSubdomain(hostname: string): string | null {
  const parts = hostname.split('.')

  if (hostname.includes('localhost') && parts.length > 1) {
    return parts[0]
  }

  return parts.length > 2 ? parts[0] : null
}

/**
 * Extracts the base domain from the given hostname.
 *
 * @param {string} hostname
 * @returns {string}
 */
export function extractBaseDomain(hostname: string): string {
  const segments = hostname.split('.')

  if (hostname.includes('localhost') && segments.length > 1) {
    return segments.slice(1).join('.')
  }

  return segments.length > 1 ? segments.slice(1).join('.') : hostname
}

/**
 * Returns a valid URL based on the tenant and hostname.
 *
 * @param {string | undefined} tenant
 * @param {string} hostname
 * @returns {string | null}
 */
export const constructValidUrlBasedOnTenant = (
  tenant: string | undefined,
  hostname: string
): string | null => {
  const currentSubdomain = extractSubdomain(hostname)

  if (tenant && currentSubdomain && currentSubdomain !== tenant) {
    const baseDomain = extractBaseDomain(hostname)
    const newHostname = `${tenant}.${baseDomain}`
    const protocol = hostname.includes('localhost') ? 'http' : 'https'
    const newUrl = `${protocol}://${newHostname}`

    return newUrl
  }

  return null
}
